/*
 * @Author: Cookie
 * @Date: 2020-07-13 13:50:35
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-03 17:40:29
 * @Description: 
 */ 
import React, { Component } from 'react';
import './index.scss';
import CrgtEvent from '../CrgtEvent';
import _ from 'lodash';
import {eventMap} from '@/utils/constant'
import { track } from '@/wrappers';

@track
class Image extends Component {

  componentDidMount=()=>{
    const {openQuickApp} = CrgtEvent.parseUrlQuery(window.location.href);
    console.log('openQuickApp',openQuickApp)
    const isOpenQuickApp = !!openQuickApp;
    const {event} = this.props;
    if(isOpenQuickApp && event === 'openQuickApp') {
      console.log('拉起快应用')
      this.onClick()
    }
  }
  onClick = (...args) => {
    const { event = 'doNothing', handleChangePage, router, onClick } = this.props;
    onClick && onClick(...args);
    let params = {};
    params = eventMap(this.props);
    const clickEvent = !_.isEmpty(event) ? (event !== 'navLink' ? function () { CrgtEvent[`${event}`](params) } : () => { handleChangePage && handleChangePage(router) }) : null;
    clickEvent()

  }
  getClass = (size) => {
    let imgClass = 'default-img';
    switch (size) {
      case 'large': return imgClass = 'large-img';
      case 'small': return imgClass = 'small-img';
      case 'default-hz': return imgClass = 'default-hz-img';
      case 'default-vt': return imgClass = 'default-vt-img';
      case 'icon': return imgClass = 'icon-img';
      default: return imgClass
    }
  }
  render() {
    const { src, alt = '', size = 'default', style = {} } = this.props;
    let imgClass = this.getClass(size);
    style.background = `url(${src}) 0 0 / 100% no-repeat`;
    //return createElement(config);
    return (
      <div className={imgClass} style={style} onClick={this.onClick}>
        <img src={src} alt={alt} />
      </div>
    )
  }
}

export default Image;